import { render, staticRenderFns } from "./newProductsMarket.vue?vue&type=template&id=1b02844b&scoped=true&"
import script from "./newProductsMarket.vue?vue&type=script&lang=js&"
export * from "./newProductsMarket.vue?vue&type=script&lang=js&"
import style0 from "./newProductsMarket.vue?vue&type=style&index=0&id=1b02844b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02844b",
  null
  
)

export default component.exports